exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#edition .v-select__slot{border:none}#edition .v-select__slot .v-select__selection{font-size:12px}#edition>div>div:nth-child(2)>div>div:nth-child(2)>div{width:100%!important}.ribbon-button input{font-size:10px}.v-text-field.v-select .v-select__selection--comma+input{max-width:20px}.v-select.disabled,.v-select:disabled,.v-select[disabled]{pointer-events:none!important;color:#a9a9a9!important}.ribbon-button .v-menu .v-btn{margin:0}#active-layer--select .v-input.disabled .v-select__selections .v-select__selection{color:gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34af0310","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/edition/Edition.vue
// module id = 1526
// module chunks = 0